import Link from "next/link";
import Image from "next/image";
import "@/app/styles/navbar.scss";
import HamburgerMenu from "./HamburgerMenu";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faUser } from "@fortawesome/free-solid-svg-icons";

export default function Navbar({ color, filter,className }) {
  return (
    <nav
      className={"navbar font-dual font-semibold " + className}
      style={{ "--nav-color": `${color}`, "--nav-filter": `${filter}` }}
    >
      <div>
        <Link href="/" className="navbar-logo">
          <Image
            src="/HeroSection/website-header-logo.svg"
            alt="Cozy scape logo"
            width={50}
            height={50}
            loading="lazy"
          />
        </Link>
      </div>
      <div className="ref-page">
        {/* <Link href="/about">ABOUT</Link> |<Link href="/services">SERVICES</Link>{" "}
        |<Link href="/projects">PROJECTS</Link>|<Link href="/warranty">WARRANTY</Link> */}
      </div>
      <div className="mobileMenu">
        {/* <HamburgerMenu color={color} /> */}
      </div>
    </nav>
  );
}
